export default __webpack_public_path__ + "static/media/srisailamVisitTwelve.73ccf86b.jpg";